import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback, logout } from "../../auth/oidc.js";
import cfg from "../../config.js";

// Step 4: Keycloak only authenticates. The Intelog backend verifies the Keycloak
// token, resolves the real user in MongoDB by email (source of truth for roles /
// pagePermissions / tenantId), and returns an Intelog JWT + the signin payload.
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { accessToken, idToken } = await handleCallback();

        // Exchange the Keycloak token for the Intelog session (JWT + user).
        const res = await fetch(`${cfg.domain}/api/auth/keycloak`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({}),
        });

        if (res.status === 403) {
          setError("No Intelog account is linked to this Keycloak user. Please contact your administrator.");
          return;
        }
        if (!res.ok) {
          const t = await res.text().catch(() => "");
          throw new Error(`Sign-in exchange failed (${res.status}): ${t}`);
        }

        const data = await res.json();
        if (!data.accessToken) {
          setError(data.message || "Sign-in failed.");
          return;
        }

        const userData = {
          id: data.id,
          username: data.username,
          email: data.email,
          roles: data.roles,
          permission: data.permission,
          tenantId: data.tenantId,
          platformRole: data.platformRole,
          tenantRole: data.tenantRole,
          pagePermissions: data.pagePermissions || {},
          authProvider: "keycloak",
        };

        localStorage.setItem("token", data.accessToken); // Intelog JWT (backend verifies this)
        if (idToken) localStorage.setItem("kc_id_token", idToken); // for Keycloak logout
        localStorage.setItem("user", JSON.stringify(userData));
        window.location.href = "/dashboard";
      } catch (e) {
        console.error("[AuthCallback] login failed:", e);
        setError(e.message || "Login failed");
      }
    })();
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0d1117", color: "#dce8ff", fontFamily: "system-ui, sans-serif" }}>
      {error ? (
        <div style={{ maxWidth: 440, textAlign: "center", padding: 24 }}>
          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>Keycloak sign-in failed</div>
          <div style={{ fontSize: 13, color: "#f5a623", marginBottom: 16, whiteSpace: "pre-wrap" }}>{error}</div>
          <button onClick={() => logout()} style={{ padding: "8px 18px", borderRadius: 6, border: "1px solid rgba(255,255,255,0.2)", background: "transparent", color: "#dce8ff", cursor: "pointer" }}>Back to sign in</button>
        </div>
      ) : (
        <div style={{ fontSize: 14 }}>Signing you in…</div>
      )}
    </div>
  );
}
